// Initialize Sentry for the app shell (imported first by src/main.tsx). The
// config lives in src/lib/sentryInit.ts, shared with the P7 handoff page.
import { initSentry } from "./src/lib/sentryInit";
import { captureAlertActionFragment } from "./src/lib/alertActionFragment";
import { captureAccessRequestFragment } from "./src/lib/accessRequestToken";
import { captureTaskFragment } from "./src/lib/portalTaskToken";

// Alert email links carry their token in /alert-action#t=…: take it out of the
// address bar before Sentry or PostHog can record the URL.
captureAlertActionFragment();
// The same for request-for-access links (/portal/access-request#t=…, T-207).
captureAccessRequestFragment();
// And "please upload this" links (/portal/task#t=…, T-220).
captureTaskFragment();
initSentry();
